<template>
  <div>
    <p class="start-end">Início</p>
    <Multiselect
      :options="timeOptionsOpen"
      v-model="open"
      :showLabels="false"
      :showPointer="false"
      :searchable="false"
      :hideSelected="true"
      :showNoResults="false"
      placeholder="-- : --"
      @input="changePeriod"
      @open="loadOpenPeriods"
    >
      <span slot="noOptions">Selecione o primeiro período</span>
    </Multiselect>

    <div class="hairline" />

    <p class="start-end">
      Fim&nbsp;
      <span class="next-day">{{ this.nextDay ? getTomorrowName() : '' }}</span>
    </p>
    <Multiselect
      :options="timeOptionsClose"
      v-model="close"
      :showLabels="false"
      :showPointer="false"
      :searchable="false"
      :hideSelected="true"
      :showNoResults="false"
      placeholder="-- : --"
      @input="changePeriod"
      @open="loadClosePeriods"
    >
      <span slot="noOptions">Selecione o Inicio</span>
    </Multiselect>
  </div>
</template>

<script>
/* eslint-disable no-plusplus */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import Multiselect from 'vue-multiselect';
import WorkingTime from '@/plugins/core/schema/configurations/WorkingTime/WorkingTime';

export default {
  data() {
    return {
      open: '',
      close: '',
      nextDay: false,
      arrayDays: this.horaries,
      dayNames: WorkingTime.getWeekDays(),
      ForceReload: true,
      timeOptionsOpen: [],
      timeOptionsClose: [],
    };
  },
  props: {
    dataOpen: { type: String },
    dataClose: { type: String },
    horaries: { type: Array },
    weekday: { type: Object },
    period: { type: Number, default: 0 },
  },
  created() {
    this.initPeriods();
  },
  methods: {
    initPeriods() {
      this.timeOptionsOpen = this.getTimeRange();

      const todayPeriods = this.getTimeRange();
      const tomorrowPeriods = this.getTimeRange('00:00', '23:45', true);

      this.timeOptionsClose = [...todayPeriods, ...tomorrowPeriods];
    },
    loadOpenPeriods() {
      // consultar o dia anterior
      const yesterday =
        this.arrayDays[0].days[
          this.weekday.weeknum === 1 ? 6 : this.weekday.weeknum - 2
        ];
      let initialPeriod = yesterday.nextDay
        ? this.addTime(yesterday.close[yesterday.close.length - 1])
        : '00:00';

      // consultar o período anterior
      if (this.weekday.close.length > 0 && this.open !== this.weekday.open[0]) {
        initialPeriod = this.addTime(this.weekday.close[0], 15);
      }

      // gerar intervalo
      this.timeOptionsOpen = this.getTimeRange(initialPeriod);
    },
    loadClosePeriods() {
      // consultar a abertura do período
      const initialPeriod = this.open ? this.addTime(this.open) : '00:00';
      // consultar o próximo dia
      const tomorrow =
        this.arrayDays[0].days[
          this.weekday.weeknum === 7 ? 0 : this.weekday.weeknum
        ];

      const finalPeriod =
        !tomorrow.active || tomorrow.open.length === 0
          ? '23:45'
          : this.subTime(tomorrow.open[0]);

      const todayPeriods =
        initialPeriod === '24:00' ? [] : this.getTimeRange(initialPeriod);
      const tomorrowPeriods = this.getTimeRange('00:00', finalPeriod, true);

      this.timeOptionsClose = [...todayPeriods, ...tomorrowPeriods];
    },
    addTime(time, value = 15) {
      const [hour, minutes] = String(time).split(':');
      const finalHour =
        parseInt(minutes, 10) === 45
          ? parseInt(hour, 10) + 1
          : parseInt(hour, 10);
      let finalMinutes = parseInt(minutes, 10) + value;
      finalMinutes = finalMinutes === 60 ? 0 : finalMinutes;

      return `${`${finalHour}`.padStart(2, '0')}:${`${finalMinutes}`.padStart(
        2,
        '0'
      )}`;
    },
    subTime(time, value = 15) {
      const [hour, minutes] = String(time).split(':');
      const finalHour =
        parseInt(minutes, 10) === 0
          ? parseInt(hour, 10) - 1
          : parseInt(hour, 10);
      let finalMinutes = parseInt(minutes, 10) - value;
      finalMinutes = finalMinutes === -15 ? 45 : finalMinutes;

      return `${`${finalHour}`.padStart(2, '0')}:${`${finalMinutes}`.padStart(
        2,
        '0'
      )}`;
    },
    getTimeRange(begin = '00:00', end = '23:45', label = false) {
      const timeRange = this.generateTimeRange(label);
      const indexOfBegin = timeRange.indexOf(begin);
      const indexOfEnd = label
        ? timeRange.map((time) => time.substr(0, 5)).indexOf(end)
        : timeRange.indexOf(end);

      const validTimeRange = timeRange.slice(
        indexOfBegin !== -1 ? indexOfBegin : 0,
        indexOfEnd !== -1 ? indexOfEnd + 1 : timeRange.length - 1
      );

      return validTimeRange;
    },
    generateTimeRange(label = false) {
      const timeHourOptions = [];
      for (let hours = 0; hours < 24; hours++) {
        for (let minutes = 0; minutes < 4; minutes++) {
          timeHourOptions.push(
            `${`${hours}`.padStart(2, '0')}:${`${minutes * 15}`.padStart(
              2,
              '0'
            )}${label ? ` (${this.getTomorrowName()})` : ''}`
          );
        }
      }
      return timeHourOptions;
    },
    getTomorrowName() {
      return this.dayNames ? this.dayNames[(this.weekday.weeknum + 1) % 7] : '';
    },
    changePeriod() {
      const todayTimeRange = this.getTimeRange();
      const fullTimeRange = [
        ...todayTimeRange,
        ...this.getTimeRange('00:00', '23:45', true),
      ];

      if (!this.close) {
        // eslint-disable-next-line prefer-destructuring
        this.close =
          this.timeOptionsClose[
            todayTimeRange.indexOf(this.open) + 1 ||
              fullTimeRange[todayTimeRange.length]
          ];
      }

      this.nextDay =
        fullTimeRange.indexOf(this.close) > 95
          ? true
          : todayTimeRange.indexOf(this.open) >=
            todayTimeRange.indexOf(this.close);

      const periodOfNextDay = !this.nextDay
        ? { 1: false, 2: false }
        : {
            ...this.weekday.periodOfNextDay,
            [this.period]: true,
          };

      const closeTime = String(this.close).substr(0, 5);

      this.$nextTick(() => {
        this.$emit('changePeriod', {
          open: this.open,
          close: closeTime,
          nextDay: this.nextDay,
          periodOfNextDay,
        });
      });
    },
  },
  watch: {
    dataOpen: {
      immediate: true,
      handler(newValue) {
        if (this.weekday.active) {
          this.open = newValue;

          if (this.open && this.close) {
            const intOpen = +this.open.replace(':', '');
            const intClose = +this.close.replace(':', '');

            if (intOpen >= intClose) {
              this.nextDay = true;
            }
          }
        } else if (newValue === null) {
          this.open = newValue;
          this.nextDay = false;
        }
      },
    },
    dataClose: {
      immediate: true,
      handler(newValue) {
        if (this.weekday.active) {
          this.close = newValue;

          if (this.open && this.close) {
            const intOpen = +this.open.replace(':', '');
            const intClose = +this.close.replace(':', '');

            if (intOpen >= intClose) {
              this.nextDay = true;
            }
          }
        } else if (newValue === null) {
          this.close = newValue;
          this.nextDay = false;
          this.initPeriods();
        }
      },
    },
    horaries: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.arrayDays = newValue;
      },
    },
  },
  components: {
    Multiselect,
  },
};
</script>
<style scoped>
.period-box {
  opacity: 1;
  transition: 0.2s linear;
}
.period-box.removing {
  opacity: 0;
}
.period-title {
  padding-bottom: 15px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  height: 50px;
  padding: 5px 0;
}
.period-week {
  display: flex;
}
.period-day {
  width: 100%;
}
.period-day.active {
  opacity: 1;
}
.period-day.inactive {
  opacity: 0.5;
}
.day-periods {
  padding: 20px 0 10px;
}
.day-periods > .horaries {
  background-color: var(--box);
  border-radius: 5px;
  padding: 0 15px 15px;
}
.period-day.inactive .day-periods {
  pointer-events: none;
}
.day-box {
  padding: 20px;
  background: var(--background);
}
.period-day .day-box {
  border-radius: 5px;
}
.period-day:not(.is-active) {
  opacity: 0.5;
}
.period-day.active {
  opacity: 1;
}
.start-end {
  color: #d9d9d9bf;
}
.start-end .next-day {
  color: #fc9;
  font-weight: 300;
}
.hairline {
  height: 20px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  margin: 5px 0 15px;
}
.tz-value {
  font-size: 1.4em;
  padding: 15px 20px;
  background: #f6f6f6;
  color: #999;
  margin-top: 20px;
}
.tz-value span {
  font-weight: 600;
}
.day {
  font-size: 12px;
}
@media screen and (min-width: 992px) {
  .period-week.desktop {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 20px;
  }
  .period-week.mobile {
    display: none;
  }
}
@media screen and (max-width: 991px) {
  .period-title {
    margin-bottom: 15px;
  }
  .period-week {
    flex-direction: column;
  }
  .period-week.desktop {
    display: none;
  }
  .period-day .day-horaries {
    flex-direction: column;
  }
  .period-day.opened .day-horaries {
    display: block;
    margin-bottom: 10px;
  }
  .period-day {
    margin-right: 0;
    border-right: none;
    margin-bottom: 10px;
    padding: 0 5px;
  }
  .period-day:first-child {
    padding-left: 0;
  }
  .day-horaries {
    display: flex;
  }
  .day-periods {
    padding: 0;
    margin-top: 10px;
  }
  .day-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    border-radius: 5px;
  }
  .arrow-next,
  .arrow-prev {
    top: 28px;
    padding: 0 10px;
    background: 0 0;
    color: #8c8c8c;
    height: 40px;
    width: 50px;
  }
  .arrow-next[disabled],
  .arrow-prev[disabled] {
    display: none;
  }
  .arrow-prev {
    left: 25px;
  }
  .arrow-next {
    right: 25px;
  }
}
</style>
